import { request } from '../request'
import store from '../store'
/**
 * 获取file对象的url
 * @param {file对象} file 
 */
function getObjectURL(file) {
	var url = null;
	if (window.createObjectURL != undefined) { // basic
		url = window.createObjectURL(file)
	} else if (window.URL != undefined) { // mozilla(firefox)
		url = window.URL.createObjectURL(file)
	} else if (window.webkitURL != undefined) { // webkit or chrome
		url = window.webkitURL.createObjectURL(file)
	}
	return url
}

/**
 * 判断登录者的身份是否是admin
 */
function isAdmin() {
	let userName = localStorage.getItem('userName')
	if (userName == 'admin') {
		return true
	} else {
		return false
	}
}

/**
 * 清除用户信息，退出登录
 */
function clearUserInfo() {
	window.localStorage.removeItem("token")
	window.localStorage.removeItem("auth")
	window.localStorage.removeItem("entId")
	window.localStorage.removeItem("entName")
	window.localStorage.removeItem("userId")
	window.localStorage.removeItem("name")
	window.localStorage.removeItem("userName")
	window.localStorage.removeItem("roleName")
}

/**
 * 获取地址数据
 */
// function getAddressData() {
// 	let data = {
// 		type: 'RegionListN',
// 		strWhere: '',
// 		PageIndex: 1,
// 		PageSize: 1000000,
// 	}
// 	let proc = "Proc_Admin_SearchInfo" // 存储过程名
// 	let type = "ReturnDataSet"
// 	requestSys({
// 		method: "post",
// 		url: "ashx/MainReturnJson.ashx?json=" + encodeURIComponent(JSON.stringify(data)) + "&type=" + type + "&proc=" + proc,
// 	}).then(res => {
// 		if (res.flag == 0 && res.content && (res.content || []).length) {
// 			// 数据格式化
// 			let list = res.content.map(item => ({
// 				label: item.Area, value: item.keyid, code: item.keyid
// 			})).filter(item => item.value.length <= 6)
// 			let obj = {}
// 			let address = []
// 			// 按省市区分类
// 			for (let i = 0; i < list.length; i++) {
// 				let item = list[i]
// 				if (item.code.length == 2) {
// 					address.push({ label: item.label, value: item.value + '0000', code: item.code })
// 				} else if (item.code.length == 4) {
// 					let key = item.code[0] + item.code[1]
// 					if (obj[key]) {
// 						obj[key].push({ label: item.label, value: item.value + '00', code: item.code })
// 					} else {
// 						obj[key] = [{ label: item.label, value: item.value + '00', code: item.code }]
// 					}
// 				} else {
// 					let key = item.code[0] + item.code[1] + item.code[2] + item.code[3]
// 					if (obj[key]) {
// 						obj[key].push({ label: item.label, value: item.value, code: item.code })
// 					} else {
// 						obj[key] = [{ label: item.label, value: item.value, code: item.code }]
// 					}
// 				}
// 			}
// 			// 市级和省级归类
// 			for (let i = 0; i < address.length; i++) {
// 				let item = address[i]
// 				let children = obj[item.code] || []
// 				for (let j = 0; j < children.length; j++) {
// 					children[j].children = obj[children[j].code] || []
// 					delete obj[children[j].code]
// 				}
// 				address[i].children = children
// 				delete obj[item.code]
// 			}
// 			// 未归类的省级重命名
// 			for (let key in obj) {
// 				let newKey = key[0] + key[1]
// 				let list = obj[key].map(item => {
// 					let info = { ...item }
// 					item.children = [info]
// 					item.code = item.code[0] + item.code[1] + item.code[2] + item.code[3]
// 					return item
// 				})
// 				delete obj[key]
// 				if (obj[newKey]) {
// 					obj[newKey].concat(list)
// 				} else {
// 					obj[newKey] = list
// 				}
// 			}
// 			// 将未归类的省级按市级归类
// 			for (let i = 0; i < address.length; i++) {
// 				if (obj[address[i].code]) {
// 					address[i].children = address[i].children.concat(obj[address[i].code])
// 					delete obj[address[i].code]
// 				}
// 			}


// 			//添加一个默认选择
// 			address.unshift({
// 				code: "00",
// 				label: "默认",
// 				value: "000000",
// 				children: []
// 			})

// 			store.commit('setData', { key: 'citys', value: address })
// 		}
// 	}).catch(err => {
// 		window.console.log(err)
// 	})
// }
function getAddressData() {
	request({
		method: "post",
		url: "/Base/GetTreeAreaListApi",
		data: {},
		isLoad: true,
	})
		.then((res) => {
			if (res.success) {
				// 全部数据存一个副本
				let dataList = res.dataList || []
				let data = [];
				// 对数据进行过滤，有的没有三级数据，添加一级
				dataList.forEach((item, i1) => {
					data.push({
						label: item.CityName,
						value: item.CityCodes,
						children: []
					})

					item.AreaList.forEach((item2, i2) => {
						data[i1].children.push({
							label: item2.CityName,
							value: item2.CityCodes,
							children: []
						})

						// 如果二级中的AreaList为空数组，则手动添加一级
						if (item2.AreaList.length == 0) {
							data[i1].children[i2].children.push({
								value: item2.CityCodes,
								label: item2.CityName
							});
						} else {
							// 如果有数据，则进行过滤
							data[i1].children[i2].children = item2.AreaList.map(item3 => {
								return {
									value: item3.CityCodes,
									label: item3.CityName
								}
							})
						}
					})
				})
				// store.commit('setData', { key: 'areaData', value: data })
				store.commit('setData', { key: 'citys', value: data })
			}
		})
		.catch((err) => {
			console.log(err);
		});
}
export {
	getObjectURL,
	isAdmin,
	clearUserInfo,
	getAddressData
}